import { AxiosResponse } from "axios";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { WarehouseFilterRequest } from "@/main/models/request";

export abstract class IWarehouseApi {
	abstract getDomain(request: WarehouseFilterRequest): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
